import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";
import * as Lity from "lity";
import 'url-polyfill';
import { url } from "inspector";

const modalQueryParamName = 'watch-and-listen';

@Options({
    template: false,
    ui: {}
})

export default class LityURL extends Marionette.View<Backbone.Model>{
    config?: object;
    element?: any;
    source?: string;
    modalId?: string;
    lity?: any;
    isOpen?: boolean;
    dontPushNextHistoryState?: boolean;

    constructor(options?: object, config?: object) {
        super(options);
        this.config = config || {};

        this.element = this.$el[0];

        this.source = this.element.getAttribute('href');
        this.modalId = this.element.getAttribute('data-lity-url');

        this.isOpen = false;
        this.dontPushNextHistoryState = false;

        /* this code is a bit of a mess, because handling modals
            along with history state is awkward. sorry if you
            have to edit it. even more sorry if you're me in
            the future who has to edit it!

            the general idea is that each modal keeps track of
            whether it is open or not so we don't erroneously call
            the history push state methods and mess up our browser
            history. apparently older browsers fire off
            `window.onpopstate` when the page loads, but we're not
            dealing with that at the moment.
        */
    }

    onRender() {
        this.checkQueryParams();

        window.addEventListener('popstate', event => {
            this.checkQueryParams()
        });

        this.element.addEventListener('click', () => this.onOpen());
    }

    // checks query params to see if we should show lightbox on page load/history change
    checkQueryParams() {
        let url = new URL(window.location.href);
        let params = new URLSearchParams(url.search);

        if(params.has(modalQueryParamName) && params.get(modalQueryParamName) == this.modalId) {
            this.openLity();
        } else {
            this.closeLity();
        }
    }

    // opens lightbox and adds history entry (changing URL)
    onOpen() {
        if(!this.isOpen) {
            this.openLity();

            if(!this.dontPushNextHistoryState) {
                let url = new URL(window.location.href);
                let params = new URLSearchParams(url.search);

                params.append(modalQueryParamName, this.modalId);

                window.history.pushState(null, '', '?' + params.toString())
            }
        }
    }

    // closes lightbox and adds history entry (changing URL)
    onClose() {
        if(this.isOpen) {
            try {
                // Pauses a video if the modal is closed
                const videoElements = this.lity.element().find('video')
                if (videoElements.length > 0) {
                    videoElements.get(0).pause();
                }
            } finally {}
            if(!this.dontPushNextHistoryState) {
                let url = new URL(window.location.href);
                let params = new URLSearchParams(url.search);

                params.delete(modalQueryParamName);

                window.history.pushState(null, '', '?' + params.toString())

                this.isOpen = false;
            }
        }
    }

    // open the lightbox (without changing URLs or history)
    openLity() {
        this.lity = Lity(this.source);
        $(document).on('lity:close', () => this.onClose());
        try {
            // Autoplays the video when opening
            // This will only work when the user manually opens the video (if opened on page load then will NOT play due to (see https://goo.gl/xX8pDD))
            const videoElements = this.lity.element().find('video')
            if (videoElements.length > 0) {
                videoElements.get(0).play();
            }
        } finally {}
        this.isOpen = true;
    }

    // close the lightbox (without changing URLs or history)
    closeLity() {
        if(this.isOpen && this.lity) {
            this.dontPushNextHistoryState = true;
            this.lity.close();
            $(document).off('lity:close', null, () => this.onClose());
        }
    }
}



// WEBPACK FOOTER //
// ./@modules/views/lity-url.ts